import React, { useState } from 'react'
import Menu from '@mui/material/Menu'

//images
import menuIcon from '../../../../assets/img/icons/table-menu.png'
import editIcon from '@/assets/img/icons/edit.svg'
import deleteIcon from '@/assets/img/icons/delete.svg'
import historyIcon from '@/assets/img/storage/icons/history.svg'
import { trans } from '../../../../_providers/Translation'

function Index(props) {

    const [table, setTable] = useState({
        options: null
    })

    const handleTableMenu = e => {

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        })
    }

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        })
    }

    const handleEdit = id => {
        handleCloseMenu()

        props.handleEdit(id)
    }

    const handleDelete = id => {
        handleCloseMenu()

        props.handleDelete(id)
    }

    const handleHistory = id => {
        handleCloseMenu()

        props.handleHistory(id)
    }

    const handleChangeGivenDate = id => {
        handleCloseMenu()

        props.handleChangeGivenDate(id)
    }


    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >

                <div className="menu-option" onClick={() => handleHistory(props.id)}>
                    <img src={historyIcon} alt="edit" />
                    {trans('buttons.history')}
                </div>

                <div className="menu-option" onClick={() => handleEdit(props.id)}>
                    <img src={editIcon} alt="edit" />
                    {trans('buttons.edit')}
                </div>
                {props.isGiven ?
                    <div className="menu-option" onClick={() => handleChangeGivenDate(props.id)}>
                        <img src={editIcon} alt="edit" />
                        {trans('buttons.changeGivenDate')}
                    </div>
                    :
                    <>
                    </>
                }
                {props.deletable &&
                    <div
                        className="menu-option"
                        onClick={() => handleDelete(props.id)}
                        style={{
                            color: "#EC5252"
                        }}
                    >
                        <img src={deleteIcon} alt="delete" />
                        {trans('buttons.delete')}
                    </div>
                }
            </Menu>
        </>
    )
}

export default Index
